import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageTransactionList
 * @description
 * # manageTransactionList
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageTransactionList', ($ngRedux, $scope, $rootScope, $location, $route) => {
    if (!$scope.isAdminUser) {
      $location.path('/');
    }

    $scope.processParams = () =>
      new Promise((resolve) => {
        const { transactionId, petId } = $route.current.params;
        if (transactionId === 'submit-invoice') {
          $rootScope.openComponent({ component: 'submit-invoice' });
        } else if (transactionId) {
          const beforeRoute = `${$rootScope.routes.transaction}/${transactionId}`;
          const closeRoute = $rootScope.routes.transaction;
          $scope.showTransactionDetail({
            transactionId: transactionId,
            beforeRoute: beforeRoute,
            closeRoute: closeRoute,
          });
        }
        if (petId) {
          $scope.onSelectPet({ petId: petId });
        }
        resolve(true);
      });

    $scope.generateTransactionbeforeRoute = (id) => {
      return `${$rootScope.routes.transaction}/${id}`;
    };

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.transaction;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.table = {
      name: 'Manage Transactions',
      options: {
        endpoint: '/2.0/transactions/',
        endpoint_data_key: 'transactions',
        per_page_options: [15, 25, 50, 100, 200],
        records_per_page: 15,
        row_style: 'standard',
        scale_up: false,
        search_key: 'Transactions',
        search_required: false,
      },
      actions: [
        {
          name: 'Submit Invoice',
          link: '#',
          onclick: () => {
            $rootScope.openComponent({ component: 'submit-invoice' });
          },
          order: 0,
          superuser: false,
        },
      ],
      columns: [
        {
          name: 'Date Purchased',
          options: {
            content: '{{ record.date_purchased }}',
            class: '',
          },
        },
        {
          name: 'Date Submitted',
          options: {
            content: '{{ record.date_submitted }}',
            class: '',
          },
        },
        {
          name: 'User',
          options: {
            content:
              '<a ng-if="record.user.first_name || record.user.last_name" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
              '{{ record.user.first_name }} {{ record.user.last_name }}' +
              '</a>' +
              '<br ng-if="record.user.contact_information.email && (record.user.first_name || record.user.last_name)" />' +
              '<a ng-class="{\'small email\': (record.user.first_name || record.user.last_name)}" ng-if="record.user.contact_information.email" href="#" ng-href="/admin/users/manage-users/{{ record.user.id }}">' +
              '{{ record.user.contact_information.email }}' +
              '</a>',
            class: '',
          },
        },
        {
          name: 'Status',
          options: {
            content: '{{ record.status.name }}',
            class: '',
          },
        },
        {
          name: 'Points',
          options: {
            content:
              '{{ record.total_points_awarded ? record.total_points_awarded : record.points_awaiting_fulfillment || 0 }}' +
              ' <span ng-if="record.status.id == 1" class="bold italic">(pending)</span>',
            class: '',
          },
        },
        {
          name: 'Additional Details',
          options: {
            content: `<span class="bold italic">Transaction ID:</span> {{ record.id }}`,
            class: '',
          },
        },
        {
          name: 'Notes/Action',
          options: {
            content: `<a href="#" ng-click="showTransactionDetail({transactionId: record.id, beforeRoute: generateTransactionbeforeRoute(record.id), closeRoute: $root.routes.transaction})">View Transaction Details</a>`,
            class: '',
          },
        },
      ],
      filters: [
        {
          name: 'User',
          type: 'angucomplete',
          options: {
            class: 'user-filter above-divider',
            query_string_parameter: 'user_id',
            remove_all: true,
            remove_all_key: 'users',
            search_endpoint: '/2.0/users/?groups=2',
            search_endpoint_data_key: 'data',
            selected: [],
            selected_key: ['first_name', 'last_name'],
            selected_remove_key: 'id',
          },
          angucomplete_parameters: {
            id: 'user-name',
            placeholder: 'User Name',
            pause: 1000,
            datafield: 'users',
            isclearafterselect: true,
            selectedobject: 'nameEmail',
            searchfields: 'first_name,last_name,email',
            titlefield: 'first_name,last_name',
            descriptionfield: ['contact_information', 'email'],
            minlength: 2,
            inputclass: 'form-control form-control-small',
            matchclass: 'highlight',
            searchfn: $scope.filterUsers,
            nextfn: $scope.filterUsersPage,
            onselect: $scope.setSelectedUsers,
            preselected: [],
            isUser: true,
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Point Adjustments',
          type: 'single_choice',
          options: {
            choices: {
              All: { type: 'standard', state: true, value: 'all', order: 0 },
              'Custom Amount': {
                type: 'amount',
                state: false,
                value: 'amount',
                amount: '',
                date_field: false,
                order: 4,
                error: false,
              },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: false,
                order: 5,
                error: false,
              },
            },
            class: 'point-adjustments-filter',
            query_string_parameter: 'point_adjustment',
          },
        },
        {
          name: 'Submission Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: true, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: false, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'timeframe-filter',
            query_string_parameter: 'timeframe',
          },
        },
        {
          name: 'Purchase Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: true, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'above-divider timeframe-filter',
            query_string_parameter: 'purchase_timeframe',
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Atlas Status',
          type: 'multiple_choice',
          options: {
            choices: {},
            choices_endpoint: '/2.0/transactions/status/?order=name',
            choices_endpoint_data_key: 'transaction-statuses',
            class: 'above-divider',
            default_choice: 'Submitted',
            name_attribute: 'name',
            query_string_parameter: 'status',
            select_all: true,
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Include Transactions with Organization Submissions',
          type: 'single_choice',
          options: {
            choices: {
              'Not Included': { type: 'standard', state: true, value: 'false', order: 0 },
              'Included': { type: 'standard', state: false, value: 'true,false', order: 1 },
            },
            class: 'above-divider',
            query_string_parameter: 'organization_id_assigned',
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Submission Status',
          type: 'multiple_choice',
          options: {
            choices: {
              'Requested Submission': { state: true, value: 'requested', order: 0 },
              'Submission Not Requested': { state: true, value: 'not_requested', order: 1 },
            },
            class: '',
            query_string_parameter: 'submission_requested',
          },
        },
        {
          name: 'Error Status',
          type: 'multiple_choice',
          options: {
            choices: {
              'Has Errored': { state: true, value: 'errored', order: 0 },
              'Not Errored': { state: true, value: 'not_errored', order: 1 },
            },
            class: 'above-divider',
            query_string_parameter: 'error_status',
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Promotion Code',
          type: 'multi_level_multiple_choice',
          options: {
            choices: {},
            choices_endpoint: '/2.0/promotion-codes/?paginate=false&type_id=1',
            choices_endpoint_data_key: 'promotion-codes',
            class: 'above-divider',
            level: [
              { name: 'Applied', value: 'applied', state: true, order: 0 },
              { name: 'Not Applied', value: 'not_applied', state: true, order: 1 },
            ],
            name_attribute: 'code',
            query_string_parameter: 'promotion_codes',
            select_all: true,
          },
        },
        {
          name: 'Divider',
          type: 'divider',
          options: {
            class: '',
            select_all: true,
          },
        },
        {
          name: 'Fulfillment Issues',
          type: 'multiple_choice',
          options: {
            choices: {
              'Point Mismatch': { state: false, value: 'point_mismatch', order: 0 },
              'Promotion Code Activity Failed': {
                state: false,
                value: 'activity_failed',
                order: 1,
              },
            },
            class: '',
            query_string_parameter: 'fulfillment_issues',
          },
        },
        {
            name: 'Divider',
            type: 'divider',
            options: {
              class: '',
              select_all: true,
            },
        },
        {
          name: 'Organizations',
          type: 'angucomplete',
          options: {
            class: 'organization-filter',
            query_string_parameter: 'organizations',
            remove_all: true,
            remove_all_key: 'organizations',
            search_endpoint: '/2.0/organizations/',
            search_endpoint_data_key: 'data',
            selected: [],
            selected_key: ['name'],
            selected_remove_key: 'id',
          },
          angucomplete_parameters: {
            id: 'organization-name',
            placeholder: 'Organization Name',
            pause: 1000,
            datafield: 'organizations',
            isclearafterselect: true,
            selectedobject: 'name',
            searchfields: 'name',
            titlefield: 'name',
            descriptionfield: null,
            minlength: 2,
            inputclass: 'form-control form-control-small',
            matchclass: 'highlight',
            searchfn: $scope.filterOrganizations,
            nextfn: $scope.filterOrganizationsPage,
            onselect: $scope.setSelectedOrganizations,
            preselected: [],
            isUser: false,
          },
        },
      ],
      sort_options: {
        date_submitted: {
          state: true,
          value: '1',
          title: 'Submission Date',
          order: 0,
        },
        date_purchased: {
          state: false,
          value: '-1',
          title: 'Purchase Date',
          order: 1,
        },
        status__name: {
          state: false,
          value: '1',
          title: 'Transaction Status',
          order: 2,
        },
        total_points_awarded: {
          state: false,
          value: '-1',
          title: 'Transaction Points',
          order: 2,
        },
      },
    };

    $scope.$on('$routeChangeStart', async (event, current) => {
      if (!current?.params?.transactionId) {
        $rootScope.userId = null;
      }
    });

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
